<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-04-09 16:03:12
 * @LastEditors: game.pluto.com 66291979@qq.com
 * @LastEditTime: 2024-09-13 15:46:06
 * @FilePath: /lobby/src/views/GameView.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div style="width: 100%; height: 100%">
    <div class="boxbg">
      <div class="title_column">
        <h2 class="t_30">WELCOME TO</h2>
        <!-- <img :src="`${resBaseUrl}logo_bet.png`" style="height: 0.6rem" /> -->
        <img v-if="country != 'GH'" :src="`${resBaseUrl}logo.png`" alt="" style="height: 1rem" />
        <img
          class="logo"
          style="height: 0.6rem"
          v-else
          :src="`${resBaseUrl}logo_bigwins.png`"
          alt=""
        />
      </div>
      <div class="btn-group">
        <div class="login-btn" @click="onOpenLogin">{{ $t('userBar.login').toUpperCase() }}</div>
        <div style="height: 0.5rem" />
        <div class="register-btn" @click="onOpenRegister">
          {{ $t('userBar.register').toUpperCase() }}
        </div>
      </div>
      <div class="activity_title">
        <h2>{{ $t('firstRecharge.title') }}</h2>
        <p>{{ $t('firstRecharge.total') }}</p>
        <h1>{{ $t('firstRecharge.bonus', { bonus: bonusAmounts[country] }) }}</h1>

        <li v-if="rechargeCount < 4 && isLogin">
          <p>
            {{
              $t('firstRecharge.btnTips', {
                depositCount: getRechargeCount(rechargeCount),
                percent: activeConfig.rewardPercent
              })
            }}
          </p>
          <p>
            {{
              $t('firstRecharge.getup', {
                amount: formatMoney(activeConfig.maximumReward, 0),
                currency: balance.currencyAlias
              })
            }}
          </p>
          <div class="triangle"></div>
        </li>
        <li v-else style="display: flex; flex-direction: column; width: 65%; color: #ffddac">
          <div class="total-group">
            <p class="total-left">{{ $t('firstRecharge.tips.first.desc') }}</p>
            <p class="total-right">
              {{ $t('firstRecharge.tips.first.amount', { tips1: tipsAmount[country].tips1 }) }}
            </p>
          </div>
          <!-- <div class="total-group">
            <p class="total-left">{{ $t('firstRecharge.tips.second.desc') }}</p>
            <p class="total-right">
              {{ $t('firstRecharge.tips.second.amount', { tips2: tipsAmount[country].tips2 }) }}
            </p>
          </div>
          <div class="total-group">
            <p class="total-left">{{ $t('firstRecharge.tips.third.desc') }}</p>
            <p class="total-right">
              {{ $t('firstRecharge.tips.third.amount', { tips3: tipsAmount[country].tips3 }) }}
            </p>
          </div>
          <div class="total-group">
            <p class="total-left">{{ $t('firstRecharge.tips.fourth.desc') }}</p>
            <p class="total-right">
              {{ $t('firstRecharge.tips.fourth.amount', { tips4: tipsAmount[country].tips4 }) }}
            </p>
          </div> -->
        </li>
      </div>
      <!-- <div class="button01" @click="onDeposit">{{ $t('firstRecharge.btnname') }}</div> -->
      <!-- <div class="activity_footer" @click="onLinkServervice">
        <div class="footer-link">{{ $t('register.service') }}</div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { config } from '@/common/config'
// import BalanceTips from '@/components/BalanceTipsComponent.vue'
import { BUS, POPUP } from '@/event/EventCenter'
import { getLocale } from '@/locales'
import { useDepositStore } from '@/stores/deposit'
import { useUserStore } from '@/stores/user'
import { formatMoney, unitConversion } from '@/utils/helper'
import { mapActions, mapState } from 'pinia'

export default {
  name: 'DhGameContainer',
  components: {
    // BalanceTips,
  },
  data() {
    return {
      resBaseUrl: config.resBaseUrl,
      showBalanceTips: false,
      balanceWidth: 0,
      activeConfig: {
        rewardPercent: ''
      },
      rechargeCount: 0,
      bonusAmounts: {
        ET: '50,000',
        CI: '50,000',
        KE: '50,000',
        TZ: '45,000',
        GH: '20,000'
      },
      tipsAmount: {
        ET: {
          tips1: '100%'
          // tips2: '50%',
          // tips3: '20%',
          // tips4: '20%'
        },
        CI: {
          tips1: '100%'
          // tips2: '30%',
          // tips3: '15%',
          // tips4: '15%'
        },
        KE: {
          tips1: '100%' //'200%',
          // tips2: '100%',
          // tips3: '50%',
          // tips4: '50%'
        },
        TZ: {
          tips1: '100%'
        },
        GH: {
          tips1: '100%'
        }
      },
      rulesAmount: {
        ET: {
          desc1: {
            value1: '20.00',
            value2: '100%',
            value3: '50,000'
          },
          desc2: {
            value1: '50',
            value2: '50',
            value3: '50'
          }
          // desc3: {
          //   value1: '20.00',
          //   value2: '50%',
          //   value3: '50,000'
          // },
          // desc4: {
          //   value1: '20.00',
          //   value2: '20%',
          //   value3: '100,000'
          // },
          // desc5: {
          //   value1: '20.00',
          //   value2: '20%',
          //   value3: '200,000'
          // }
        },
        CI: {
          desc1: {
            value1: '200',
            value2: '100%',
            value3: '50,000'
          },
          desc2: {
            value1: '200',
            value2: '200',
            value3: '200'
          }
          // desc3: {
          //   value1: '200',
          //   value2: '30%',
          //   value3: '10,000'
          // },
          // desc4: {
          //   value1: '200',
          //   value2: '15%',
          //   value3: '10,000'
          // },
          // desc5: {
          //   value1: '200',
          //   value2: '15%',
          //   value3: '10,000'
          // }
        },
        KE: {
          desc1: {
            value1: '49',
            value2: '100%',
            value3: '50,000'
          },
          desc2: {
            value1: '50',
            value2: '50',
            value3: '50'
          }
          // desc3: {
          //   value1: '49',
          //   value2: '100%',
          //   value3: '50,000'
          // },
          // desc4: {
          //   value1: '49',
          //   value2: '50%',
          //   value3: '100,000'
          // },
          // desc5: {
          //   value1: '49',
          //   value2: '50%',
          //   value3: '200,000'
          // }
        },
        TZ: {
          desc1: {
            value1: '1,000',
            value2: '100%',
            value3: '45,000'
          },
          desc2: {
            value1: '1,000',
            value2: '1,000',
            value3: '1,000'
          }
        },
        GH: {
          desc1: {
            value1: '10',
            value2: '100%',
            value3: '20,000'
          },
          desc2: {
            value1: '100',
            value2: '100',
            value3: '100'
          }
        }
      }
    }
  },
  computed: {
    ...mapState(useUserStore, ['isLogin', 'balance', 'country'])
  },
  mounted() {
    // this.$bus.$emit(BUS.FULL_SCREEN, true)
    if (this.isLogin) {
      this.depositActivity().then((res) => {
        this.activeConfig = res.config
        this.rechargeCount = res.rechargeCount
      })
    }
  },
  methods: {
    formatMoney,
    unitConversion,
    ...mapActions(useDepositStore, {
      depositActivity: 'depositActivity'
    }),
    showBalanceInfo() {
      this.balanceWidth = this.$refs.balanceRef.clientWidth - 25
      this.showBalanceTips = !this.showBalanceTips
    },
    onDeposit() {
      if (this.isLogin) {
        if (this.country == 'CI') {
          this.$router.replace('/depositci')
        } else if (this.country == 'KE') {
          this.$router.replace('/depositke')
        } else if (this.country == 'TZ') {
          this.$router.replace('/deposittz')
        } else if (this.country == 'GH') {
          this.$router.replace('/depositgh')
        } else {
          this.$router.replace('/deposit')
        }
      } else {
        this.onOpenLogin()
      }
    },
    onOpenLogin() {
      // this.$bus.$emit(BUS.FULL_SCREEN, false)
      window.pageHistory = null
      this.$router.replace('/')
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'firstRecharge', to: POPUP.LOGIN, show: true })
    },
    onOpenRegister() {
      // this.$bus.$emit(BUS.FULL_SCREEN, false)
      window.pageHistory = null
      this.$router.replace('/')
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'firstRecharge', to: POPUP.REGISTER, show: true })
    },
    onLinkServervice() {
      this.$bus.$emit(BUS.SHOW_CHAT)
    },
    getRechargeCount(count) {
      if (getLocale() == 'en') {
        return ['First', 'Second', 'Third', 'Fourth'][count]
      } else if (getLocale() == 'am') {
        return ['አንደኛ', 'ሁለተኛ', 'ሶስተኛ', 'አራተኛ'][count]
      } else if (getLocale() == 'fr') {
        return ['Premier', 'Deuxième', 'Troisième', 'Quatrième'][count]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.boxbg {
  width: 100%;
  height: calc(100% - var(--user-bar-height) - var(--user-bar-height));
  padding-top: var(--user-bar-height);
  background:
    radial-gradient(rgba(170, 136, 74, 0.3) 8%, transparent 10%) 0% 0%,
    linear-gradient(
        45deg,
        rgba(170, 136, 74, 0) 40%,
        rgba(170, 136, 74, 0.6) 49.8% 50.2%,
        rgba(170, 136, 74, 0) 60%
      )
      0% 0%,
    linear-gradient(
        -45deg,
        rgba(170, 136, 74, 0) 40%,
        rgba(170, 136, 74, 0.6) 49.8% 50.2%,
        rgba(170, 136, 74, 0) 60%
      )
      0% 0% #000000;
  background-size: 1.2rem 1.2rem;
  position: absolute;
  z-index: -2;

  .title_column {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 0.2rem;

    .t_30 {
      font-size: 0.3rem;
      color: #ffddac;
      margin-bottom: 0.4rem;
    }
  }

  .btn-group {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 0.72rem;
    margin-bottom: 0.5rem;

    .login-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 67%;
      height: 0.9rem;
      background: #000;
      border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
      border: 0.02px solid #aa884a;

      font-family: Droid Sans;
      font-weight: 400;
      font-size: 0.3rem;
      color: #aa884a;
      line-height: 0.22rem;
    }

    .register-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 67%;
      height: 0.9rem;
      background: #aa884a;
      border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;

      font-family: Droid Sans;
      font-weight: 400;
      font-size: 0.3rem;
      color: #ffffff;
      line-height: 0.22rem;
    }
  }

  .activity_title {
    text-align: center;
    height: auto;
    width: 100%;
    margin: 1rem 0 0.8rem 0;
    overflow: hidden;

    .triangle {
      width: 0;
      height: 0;
      border-top: 0.4rem solid #ffddac;
      border-right: 0.4rem solid transparent;
      border-left: 0.4rem solid transparent;
      margin: 0.2rem auto 0 -0.4rem;
      position: absolute;
      z-index: 1;
      display: inline;
      filter: drop-shadow(#ffddac 0 0 0.2rem);
    }

    h1 {
      font-family: Oswald_Bold;
      text-align: center;
      text-transform: uppercase;
      font-size: 1rem;
      line-height: 1rem;
      letter-spacing: 0.01rem;
      margin: 0.2rem 0 0.8rem 0;
      padding: 0;
      animation: rotate 2s ease-in-out alternate infinite;
    }

    h2 {
      font-size: 0.5rem;
      margin: 0;
      padding: 0;
      background-image: linear-gradient(
        #e2c052 28%,
        #fff7d2 42%,
        #fff7d2 49%,
        #e4b555 49%,
        #ffddac 90%
      );
      -webkit-background-clip: text;
      color: transparent;
      filter: drop-shadow(#894700 0.08rem 0.03rem 0.01rem);
    }

    p {
      font-size: 0.3rem;
      line-height: 1rem;
    }

    li {
      display: inline-block;
      padding: 3% 5%;
      margin: 0 auto;
      border-radius: 0.18rem;
      box-shadow:
        #ffddac 0 0 0.01rem inset,
        #ffddac 0 0 0.02rem inset,
        #ffddac 0 0 0.03rem inset,
        #ffddac 0 0 0.1rem inset,
        #ffddac 0 0 0.15rem inset,
        #ffddac 0 0 0.2rem inset;

      p {
        font-size: 0.28rem;
        line-height: 0.6rem;
        margin: 0;
        padding: 0;
        text-align: center;
        white-space: nowrap;
      }

      p:nth-child(1) {
        font-family: Oswald_Bold;
        font-size: 0.36rem;
        letter-spacing: 0.02rem;
      }

      i {
        font-size: 0.7rem;
        margin: 0 0 0 50%;
        padding: 0;
        display: block;
        position: absolute;
        float: left;
        z-index: 1;
        left: -0.35rem;
      }

      .total-group {
        display: flex;
        justify-content: space-between;

        .total-left {
          font-family: Droid Sans;
          font-size: 0.28rem;
          line-height: 0.6rem;
          margin: 0;
          padding: 0;
          float: left;
          display: inline;
          white-space: nowrap;
        }

        .total-right {
          font-family: Oswald_Bold;
          font-size: 0.36rem;
          float: right;
          text-align: right;
        }
      }
    }
  }

  .button01 {
    font-size: 0.48rem;
    margin: 0.5rem auto 1rem auto;
    cursor: pointer;
    touch-action: manipulation;
    position: relative;
    border: 1px solid #825c2d;
    border-radius: 0.8rem;
    padding: 0.4rem 1rem;
    background-color: #825c2d;
    background-image: radial-gradient(75% 50% at 50% 0, #ffddad, transparent),
      radial-gradient(75% 35% at 50% 80%, #dfc572, transparent);
    box-shadow:
      inset 0 -2px 4px 1px rgba(170, 136, 74, 0.6),
      inset 0 -4px 4px 1px #dfc572,
      inset 0 0 2px 1px rgba(255, 255, 255, 0.2),
      0 1px 4px 1px rgba(145, 108, 56, 0.2),
      0 2px 4px 1px rgba(0, 0, 0, 0.5),
      0 0 2rem rgba(255, 247, 210, 1);
    color: #fff;
    text-shadow: 0 0.03rem 0.01rem #825c2d;
    transition-property: border-color, transform, background-color;
    transition-duration: 0.2s;
    display: block;
    width: 3rem;
    text-align: center;
  }

  .button01::after {
    content: '';
    position: absolute;
    top: 0.01rem;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 0.8rem;
    width: 80%;
    height: 40%;
    background-image: linear-gradient(to bottom, #fff7d2, transparent);
    opacity: 0.75;
  }

  .button01:hover {
    transform: scale(1.04);
  }

  .button01:active {
    transform: scale(1);
  }

  .activity_rule {
    margin: 25% 10% 10% 10%;
    width: 80%;
  }

  .activity_rule::before {
    content: '';
    position: absolute;
    background-color: #672501;
    width: 6rem;
    height: 6rem;
    border-radius: 50%;
    margin: -0.6rem 0 0 -1rem;
    float: left;
    filter: blur(0.6rem);
    z-index: -1;
    display: block;
  }

  .activity_rule::after {
    content: '';
    position: absolute;
    background-color: #8e4c00;
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    filter: blur(0.6rem);
    margin: -4.5rem 0 0 2.8rem;
    z-index: -1;
    display: block;
  }

  .activity_rule h3 {
    font-size: 0.3rem;
    line-height: 0.4rem;
    text-align: center;
    color: #ffddac;
  }

  .activity_rule li {
    margin-bottom: 0.2rem;
    list-style-type: disc;
    list-style-position: inside;
    width: 100%;
    font-size: 0.24rem;
    color: #ffddac;
  }

  .activity_footer {
    text-align: center;
    margin: 0;
    padding: 0.3rem 0;
    height: auto;
    width: 100%;

    .footer-link {
      text-decoration: underline;
      color: #ffddac;
      font-size: 0.24rem;
    }
  }
}

@keyframes rotate {
  0% {
    color: #ffebcc;
    transform: rotateY(-20deg);
    text-shadow:
      0.01rem 0.01rem #591701,
      0.03rem 0.01rem #602200,
      0.05rem 0.02rem #672501,
      0.07rem 0.02rem #6c2a01,
      0.09rem 0.03rem #753300,
      0.11rem 0.03rem #7d3b00,
      0.13rem 0.04rem #824000,
      0.15rem 0.04rem #894700,
      0.17rem 0.05rem #8e4c00;
  }

  40% {
    color: #ffddac;
  }

  60% {
    color: #ffddac;
  }

  100% {
    color: #ffd697;
    transform: rotateY(20deg);
    text-shadow:
      -0.01rem 0.01rem #591701,
      -0.03rem 0.01rem #602200,
      -0.05rem 0.02rem #672501,
      -0.07rem 0.02rem #6c2a01,
      -0.09rem 0.03rem #753300,
      -0.11rem 0.03rem #7d3b00,
      -0.13rem 0.04rem #824000,
      -0.15rem 0.04rem #894700,
      -0.17rem 0.05rem #8e4c00;
  }
}
</style>
